module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors-refine/img_example02-264821ea2f99df5eec548b28022a9d96.png";